import { useRouter } from 'next/router';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';

import { flushState } from '~/src/entities/speed-bonus/context/actions';
import { useContextDispatch, useContextSelector } from '~/src/entities/speed-bonus/context/hooks';

const SuccessRequest = (): JSX.Element => {
    const ctxDispatch = useContextDispatch();
    const businessLogic = useContextSelector(state => state.businessLogic);
    const { push } = useRouter();

    const onClose = () => {
        businessLogic?.afterSuccessConnection && businessLogic.afterSuccessConnection();
        ctxDispatch(flushState());
    };

    const redirectHandler = () => {
        push('/lk/orders');
        onClose();
    };

    return (
        <ButtonGroup>
            <Button size={'large'} bType={'action'} onClick={redirectHandler}>Перейти к&nbsp;заявке</Button>
            <Button size={'large'} bType={'secondary'} onClick={onClose}>Закрыть</Button>
        </ButtonGroup>
    );
};

export default SuccessRequest;
